import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import RefreshIcon from '@mui/icons-material/Refresh';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Box, IconButton, Slide, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { startConnectivityTracking } from './networkReconnect';

function NetworkStatusBanner() {
  const { t } = useTranslation();
  const [connected, setConnected] = useState(true);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return undefined;
    }

    return startConnectivityTracking({
      getStatus: () => Network.getStatus(),
      addListener: cb => Network.addListener('networkStatusChange', cb),
      onStatusChange: setConnected,
      onReload: () => window.location.reload(),
    });
  }, []);

  if (!Capacitor.isNativePlatform()) return null;

  return (
    <Slide in={!connected} direction="down" mountOnEnter unmountOnExit>
      <Box
        role="status"
        aria-live="polite"
        sx={{
          position: 'fixed',
          top: 'env(safe-area-inset-top)',
          left: 'env(safe-area-inset-left)',
          right: 'env(safe-area-inset-right)',
          zIndex: theme => theme.zIndex.appBar + 10,
          bgcolor: 'error.main',
          color: 'error.contrastText',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 1,
          boxShadow: 3,
        }}
      >
        <WifiOffIcon fontSize="small" />
        <Typography variant="body2" sx={{ flexGrow: 1, fontWeight: 500 }}>
          {t('network.offline')}
        </Typography>
        <IconButton
          size="small"
          aria-label={t('actions.retry')}
          onClick={() => window.location.reload()}
          sx={{ color: 'inherit' }}
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Box>
    </Slide>
  );
}

export default NetworkStatusBanner;
